import { getRequestProps } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
export function CasinoPlayerActivityRequestFormatter(message) {
    const { baseUrl, endpoint, method, headers } = getRequestProps(ConnectionNames.casinoPlayerActivity, message);
    let url = `${baseUrl}${endpoint}`;
    if (typeof message.params !== "undefined") {
        url += `?platform=${message.params}`;
    }
    return new Request(url, {
        method,
        headers
    });
}
//# sourceMappingURL=CasinoPlayerActivityRequestFormatter.js.map